export default {
  "Yhteiset liitteet": "Yhteiset liitteet",
  "attachment_lang_tip": "Yhteiset liitteet näkyvät kaikille kielivalinnasta riippumatta. Kieliversioiden liitteet näkyvät vain kyseisen kielivalinnan käyttäjille.",
  "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.": "Käännös suoritettu. Varmista käännöksen oikeellisuus ennen tallentamista.",
  "Suorita käännös": "Suorita käännös",
  "Automaattinen käännös": "Automaattinen käännös",
  "auto_translate_notice": "Testaamme Piirissä tekoälykäännöstyökalua. Yritys vastaa itse käännösten sisällöistä. Työkalu on tarkoitettu vain Piirin sisältöjen kääntämiseen. Palautetta voi lähettää osoitteeseen tuki@sisainenviestinta.fi.",
  "deepl_notice": "Sisällön kääntämiseen käytetään <a href='https://www.deepl.com/en/translator' target='_blank'> DeepL -palvelua</a>. Huomaa, että käännettävä teksti lähetetään DeepLin palvelimille käsiteltäväksi. Yritys on vastuussa käännetyn sisällön oikeellisuuden ja soveltuvuuden varmistamisesta.",
  "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!": "Haluatko varmasti poistaa käyttäjän? Toimintoa ei voi perua!",
  "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva": "Jos haluat päivittää kuvan, poista ensin olemassa oleva kuva",
  "ryhmää": "ryhmää",
  "Push-ilmoitukset käytössä": "Push-ilmoitukset käytössä",
  "Kansikuvat": "Kansikuvat",
  "Ei kuvia, näytetään logo": "Ei kuvia, näytetään logo",
  "Lisää uusi kansikuva": "Lisää uusi kansikuva",
  "Enintään 5 kuvaa voidaan lisätä": "Enintään 5 kuvaa voidaan lisätä",
  "Haluatko varmasti poistaa kuvan?": "Haluatko varmasti poistaa kuvan?",
  "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px": "Kuvien suositeltu kuvasuhde on 16:9, esim. 1920x1080px",
  "Kuvat näytetään kuvakarusellissa": "Kuvat näytetään kuvakarusellissa",
  "Vastauksiin liitetään nimi automaattisesti": "Vastauksiin liitetään nimi automaattisesti",
  "Kyselyyn voi vastata useita kertoja": "Kyselyyn voi vastata useita kertoja",
  "Vastaukset kerätään anonyymisti": "Vastaukset kerätään anonyymisti",
  "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu": "Tätä asetusta ei voi muuttaa sen jälkeen kun kyselyyn on vastattu",
  "Salli useita vastauksia samalta käyttäjältä": "Salli useita vastauksia samalta käyttäjältä",
  "Palautteiden käsittelijäksi voidaan...": "Huom. Palautteiden käsittelijäksi voidaan valita pääkäyttäjä tai ryhmän ylläpitäjä. Voit lisätä ryhmän ylläpitäjän oikeudet käyttäjän omissa tiedoissa kohdassa Käyttäjät.",
  "Kaikki muutokset kirjataan lokiin": "Kaikki palautteiden käsittelijöihin tehtävät muutokset tallentuvat lokitietoihin. (Katso loki klikkaamalla oikealla olevaa ikonia.)",
  "Valitse käsittelyoikeudet": "Valitse käsittelyoikeudet",
  "Käsittelyoikeudet": "Käsittelyoikeudet",
  "Tallennus onnistui": "Tallennus onnistui",
  "Aikaleima": "Aikaleima",
  "Suorittanut": "Suorittanut",
  "Kohdekäyttäjä": "Kohdekäyttäjä",
  "Tapahtuma": "",
  "Loki": "Loki",
  "CategoryInfo": 'Palautteiden luokittelua ei ole otettu käyttöön. Luo erilaisille palautetyypeille omia kategorioita valitsemalla "Uusi palautetyyppi" ja kirjoittamalla ohjeet palautetyyppiin.',
  "Palautetyypit": "Palautetyypit",
  "Palautetyypin nimi": "Palautetyypin nimi",
  "Valitse palautteen tyyppi": "Valitse palautteen tyyppi",
  "Otsikko on pakollinen kaikilla kielillä": "Otsikko on pakollinen kaikilla kielillä",
  "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)": "Ohje palautteen lähettäjälle (esim. mitä tietoja ilmoitukseen tulee lisätä)",
  "Lyhyt kuvaus (milloin palautetyyppiä käytetään)": "Lyhyt kuvaus (milloin palautetyyppiä käytetään)",
  "Uusi palautetyyppi": "Uusi palautetyyppi",
  "Palautteiden luokittelu": "Palautteiden luokittelu",
  "Haluatko varmasti ottaa palautteen käsittelyyn?": "Haluatko varmasti ottaa palautteen käsittelyyn?",
  "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten": "Käyttäjä on jättänyt yhteystiedot yhteydenottoa varten",
  "Palaute on käsitelty": "Palaute on käsitelty",
  "Palauteilmoitukset": "Palautteiden käsittelijät",
  "Kirjoita viesti": "Kirjoita viesti",
  "Sinä": "Sinä",
  "Voit lähettää yhden viestin vastauksena": "Voit lähettää yhden viestin vastauksena",
  "Haluatko varmasti lähettää viestin?": "Haluatko varmasti lähettää viestin?",
  "Palautteet": "Palautteet",
  "Näytä lähetetyt palautteet": "Näytä lähetetyt palautteet",
  "Piilota lähetetyt palautteet": "Piilota lähetetyt palautteet",
  "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?": "Haluatko jättää yhteystietosi henkilökohtaista vastausta varten?",
  "Käsitelty": "Käsitelty",
  "Avoin": "Avoin",
  "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn": "Voit lähettää palautteen lähettäjälle viestin tai vastauksen sen jälkeen, kun palaute on otettu käsittelyyn",
  "Tietoja": "Tietoja",
  "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.": "Palautteen lähettäjä voi vastata lähettämääsi viestiin tai viesteihin niin kauan, kunnes palaute on merkitty käsitellyksi.",
  "Käyttäjä": "Käyttäjä",
  "Yhteystiedot": "Yhteystiedot",
  "Viestit": "Viestit",
  "Käyttäjä ei ole jättänyt yhteystietoja": "Käyttäjä ei ole jättänyt yhteystietoja",
  "Lähetä lisäkysymys tai vastus": "Lähetä lisäkysymys tai vastus",
  "Vie vastaukset": "Vie vastaukset",
  "Päivitykset": "Päivitykset",
  "Kutsu uudet käyttäjät": "Kutsu uudet käyttäjät",
  "Lisää uusi palautteiden käsittelijä": "Lisää uusi palautteiden käsittelijä",
  "Ilmoitus sähköpostiin": "Ilmoitus sähköpostiin",
  "Push-viesti puhelimeen": "Push-viesti puhelimeen",
  "Kutsu käyttäjiä": "Kutsu käyttäjiä",
  "Käytä viestipohjaa": "Käytä viestipohjaa",
  "Kutsuohje": "Alla oleva viesti lähetetään tekstiviestillä valituille käyttäjille. Halutessasi voit muokata \
  viestiä ennen lähetystä.",
  "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.": "Varmista, että käyttäjien puhelinnumerot ovat oikein ennen viestin lähetystä.",
  "Kutsumattomia käyttäjiä ei löytynyt": "Kutsumattomia käyttäjiä ei löytynyt",
  "Kutsu valitut käyttäjät": "Kutsu valitut käyttäjät",
  "Lähetys käynnissä, odota...": "Lähetys käynnissä, odota...",
  "Lähetys on valmis": "Lähetys on valmis",
  "Kutsu käyttäjälle": "Kutsu käyttäjälle",
  "numeroon": "numeroon",
  "epäonnistui": "epäonnistui",
  "Päivitä lista": "Päivitä lista",
  "Viesti on pakollinen": "Viesti on pakollinen",
  "Kirjoita vastaus": "Kirjoita vastaus",
  "Vastauksia": "Vastauksia",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ": "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomutooja ovat ",
  "Liitetiedosto": "Liitetiedosto",
  "Halutessasi voi liittää liitetiedoston": "Halutessasi voi liittää liitetiedoston",
  "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston": "Halutessasi voit liittää mukaan kuvan tai pdf-tiedoston",
  "Liite": "Liite",
  "Ladataan...": "Ladataan...",
  "Vastausaika on päättynyt": "Vastausaika on päättynyt",
  "Ei ilmoittautumisia": "Ei ilmoittautumisia",
  "Voit lähettää viestin Ctrl Enter painikkeilla": "Voit lähettää viestin Ctrl + Enter painikkeilla",
  "Omat keskustelut": "Omat keskustelut",
  "Näytä keskustelukanavat": "Näytä keskustelukanavat",
  "Yksityinen kanava": "Yksityinen kanava",
  "Hallinnoit tätä kanavaa": "Hallinnoit tätä kanavaa",
  "Aloita uusi keskustelu": "Aloita uusi keskustelu",
  "Miten palautteet käsitellään": "Miten palautteet käsitellään",
  "Haku": "Haku",
  "Omat tiedot ja asetukset": "Omat tiedot ja asetukset",
  "Julkaisuaika on pakollinen": "Julkaisuaika on pakollinen",
  "Kuvaus...": "Kuvaus...",
  "Saapunut ...": "Saapunut ...",
  "Nimi puuttuu": "Nimi puuttuu",
  "Haluatko varmasti poistaa tapahtuman?": "Haluatko varmasti poistaa tapahtuman?",
  "Ylläpito": "Ylläpito",
  "Etusivu": "Etusivu",
  "Hallinta": "Hallinta",
  "Muut": "Lisää",
  "Omat tiedot": "Omat tiedot",
  "Kirjaudu ulos": "Kirjaudu ulos",
  "Lähetä": "Lähetä",
  "Olet vastannut kyselyyn": "Olet vastannut kyselyyn",
  "Kyselyt": "Kyselyt",
  "Vastausaika päättyy": "Vastausaika päättyy",
  "Ei kyselyjä": "Ei kyselyjä",
  "Uusi tiedosto lisätty": "Uusi tiedosto lisätty",
  "Yritys": "Yritys",
  "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.": "Raahaa kuva tähän tai klikkaa tästä ja valitse kuva tiedostoista.",
  "Kuponki": "Kuponki",
  "Otsikko": "Otsikko",
  "Kuvaus": "Kuvaus",
  "Etu julkaistaan heti": "Etu julkaistaan heti",
  "Etu tallennetaan luonnoksena": "Etu tallennetaan luonnoksena",
  "Julkaise": "Julkaise",
  "Tarkista lomakkeen tiedot": "Tarkista lomakkeen tiedot",
  "Poista": "Poista",
  "Tallenna": "Tallenna",
  "Tallenna lisätieto": "Tallenna lisätieto",
  "Henkilöstöedut": "Henkilöstöedut",
  "Uusi etu": "Uusi etu",
  "Julkaistu": "Julkaistu",
  "Keskustelukanavat": "Keskustelukanavat",
  "Nimi": "Nimi",
  "Kuva": "Kuva",
  "Kanavan tyyppi": "Kanavan tyyppi",
  "Yksityinen keskustelu": "Yksityinen keskustelu",
  "Avoin ryhmäkeskustelu": "Avoin ryhmäkeskustelu",
  "Kanavaa hallinnoivat": "Kanavaa hallinnoivat",
  "Käytössä": "Käytössä",
  "Kanava on käytössä": "Kanava on käytössä",
  "Kanava ei ole käytössä": "Kanava ei ole käytössä",
  "Uusi kanava": "Uusi kanava",
  "Aktiivinen": "Aktiivinen",
  "Klo": "Klo",
  "klo": "klo",
  "Ilmoittautuminen päättyy": "Ilmoittautuminen päättyy",
  "Ilmoittautumiset": "Ilmoittautumiset",
  "#": "#",
  "Henkilö": "Henkilö",
  "Ilmoitautumisaika": "Ilmoitautumisaika",
  "Kommentti": "Kommentti",
  "Tapahtumat": "Tapahtumat",
  "Julkaise ryhmään": "Julkaise ryhmään",
  "Tapahtuman alkuaika": "Tapahtuman alkuaika",
  "Tapahtuman päättymisaika": "Tapahtuman päättymisaika",
  "Palauteasetukset": "Palauteasetukset",
  "Ilmoittautuminen": "Ilmoittautuminen",
  "Kommentti ilmoittautumisen yhteydessä": "Kommentti ilmoittautumisen yhteydessä",
  "Tapahtuma julkaistaan heti": "Tapahtuma julkaistaan heti",
  "Tapahtuma tallennetaan luonnoksena": "Tapahtuma tallennetaan luonnoksena",
  "Ryhmä on pakollinen": "Ryhmä on pakollinen",
  "Otsikko ja teksti on pakollinen": "Otsikko ja teksti on pakollinen",
  "Alkuaika on pakollinen": "Alkuaika on pakollinen",
  "Tarkista päättymisaika": "Tarkista päättymisaika",
  "Tarkista ilmoittautumisen päättymisaika": "Tarkista ilmoittautumisen päättymisaika",
  "Otsikko tai teksti puuttuu": "Otsikko tai teksti puuttuu",
  "Uusi tapahtuma": "Uusi tapahtuma",
  "Aika": "Aika",
  "Ryhmä": "Ryhmä",
  "Kysymykset & vastaukset": "Kysymykset & vastaukset",
  "Kysymys": "Kysymys",
  "Uusi kysymys": "Uusi kysymys",
  "Saapunut": "Saapunut",
  "päivää sitten": "päivää sitten",
  "Käsittelyssä": "Käsittelyssä",
  "Otettu käsittelyyn": "Otettu käsittelyyn",
  "Valmis": "Valmis",
  "Palaute": "Palaute",
  "Käyttäjä toivoo vastausta": "Käyttäjä toivoo vastausta",
  "Käyttäjä ei toivo vastausta": "Käyttäjä ei toivo vastausta",
  "Käsittely": "Käsittely",
  "Ota käsittelyyn": "Ota käsittelyyn",
  "Sisäinen lisätieto": "Sisäinen lisätieto",
  "Sisäinen lisätieto ei näy palautteen lähettäjälle": "Sisäinen lisätieto ei näy palautteen lähettäjälle",
  "Kuittaa käsitellyksi": "Kuittaa käsitellyksi",
  "Palautekanava": "Palautekanava",
  "SUODATA": "SUODATA",
  "Saapuneet": "Saapuneet",
  "Käsittely kesken": "Käsittely kesken",
  "Valmiit": "Valmiit",
  "Saapunut tänään": "Saapunut tänään",
  "Lisää kuva klikkaamalla tai raahaamalla kuva tähän": "Lisää kuva klikkaamalla tai raahaamalla kuva tähän",
  "Julkaisuaika": "Julkaisuaika",
  "Liitteet": "Liitteet",
  "Lisää uusi liitetiedosto": "Lisää uusi liitetiedosto",
  "Voit lisätä sivulle liitteitä tallennuksen jälkeen": "Voit lisätä sivulle liitteitä tallennuksen jälkeen",
  "Video": "Video",
  "Lisää uutiseen video": "Lisää uutiseen video",
  "Kysely": "Kysely",
  "Lisää julkaisuun kysymys": "Lisää julkaisuun kysymys",
  "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata": "Kyselyyn on vastattu eikä kysymyksiä voi enää muokata",
  "Kysymykset": "Kysymykset",
  "Uusi monivalintakysymys": "Uusi monivalintakysymys",
  "Uusi avoin kysymys": "Uusi avoin kysymys",
  "Kirjoita kysymys": "Kirjoita kysymys",
  "Lisää vastausvaihtoehto": "Lisää vastausvaihtoehto",
  "Kirjoita vastausvaihtoehto": "Kirjoita vastausvaihtoehto",
  "Uutinen julkaistaan julkaisaikana": "Uutinen julkaistaan julkaisaikana",
  "Uutinen tallennetaan luonnoksena": "Uutinen tallennetaan luonnoksena",
  "Uutiset": "Uutiset",
  "Uusi uutinen": "Uusi uutinen",
  "Näytä vastaukset": "Näytä vastaukset",
  "Julkaisupäivä": "Julkaisupvm",
  "Meidän yritys": "Meidän yritys",
  "Valitse kuva": "Valitse kuva",
  "Lisää sivulle video": "Lisää sivulle video",
  "Vimeo videon id": "Vimeo videon id",
  "Sivu julkaistaan heti": "Sivu julkaistaan heti",
  "Sivu tallennetaan luonnoksena": "Sivu tallennetaan luonnoksena",
  "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.": "Tiedostomuoto ei ole tuettu. Tuettuja tiedostomuotoja ovat jpeg sekä png.",
  "Uusi sivu": "Uusi sivu",
  "Lisää alasivu": "Lisää alasivu",
  "Yhteenveto": "Yhteenveto",
  "Vastaukset": "Vastaukset",
  "Vastausaika": "Vastausaika",
  "Otsikko ja kuvaus on pakollinen": "Otsikko ja kuvaus on pakollinen",
  "Päivämäärä on pakollinen": "Päivämäärä on pakollinen",
  "Kyselyssä ei ole yhtään kysymystä": "Kyselyssä ei ole yhtään kysymystä",
  "Tarkista kysymykset": "Tarkista kysymykset",
  "Otsikko tai kuvaus puuttuu": "Otsikko tai kuvaus puuttuu",
  "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?": "Haluatko varmasti poistaaa kyselyn ja kaikki sen vastaukset?",
  "Uusi kysely": "Uusi kysely",
  "Tiedosto": "Tiedosto",
  "Linkki": "Linkki",
  "Valitse uusi tiedosto": "Valitse uusi tiedosto",
  "Tämä tieto on pakollinen": "Tämä tieto on pakollinen",
  "Max 500 merkkiä": "Max 500 merkkiä",
  "Tiedosto julkaistaan heti": "Tiedosto julkaistaan heti",
  "Tiedosto tallennetaan luonnoksena": "Tiedosto tallennetaan luonnoksena",
  "Tiedosto puuttuu": "Tiedosto puuttuu",
  "Linkki puuttuu": "Linkki puuttuu",
  "Tiedostot": "Tiedostot",
  "Uusi tiedosto": "Uusi tiedosto",
  "Avaa": "Avaa",
  "Tyyppi": "Tyyppi",
  "Miten palautteet käsitellään": "Miten palautteet käsitellään",
  "Asetukset": "Asetukset",
  "Palautteiden käsittelykäytäntö": "Palautteiden käsittelykäytäntö",
  "Käyttäjät": "Käyttäjät",
  "Etunimi": "Etunimi",
  "Sukunimi": "Sukunimi",
  "Puhelin": "Puhelin",
  "Sähköposti": "Sähköposti",
  "Työtehtävä": "Työtehtävä",
  "Näytä sähköposti kaikille": "Näytä sähköposti kaikille",
  "Näytä puhelinnumero kaikille": "Näytä puhelinnumero kaikille",
  "Ryhmät": "Ryhmät",
  "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin": "Käyttäjä on yrityksen pääkäyttäjä, jolla on oikeudet julkaista kaikkiin ryhmiin",
  "Ryhmän ylläpitäjä": "Ryhmän ylläpitäjä",
  "Suodata": "Suodata",
  "Uusi käyttäjä": "Uusi käyttäjä",
  "Näytä ryhmän ylläpitäjät": "Näytä ryhmän ylläpitäjät",
  "Sähköposti": "Sähköposti",
  "Kaikki käyttäjät": "Kaikki käyttäjät",
  "Yrityksen pääkäyttäjät": "Yrityksen pääkäyttäjät",
  "Näytä kuponki": "Näytä kuponki",
  "Sulje": "Sulje",
  "Kirjoita viestisi": "Kirjoita viestisi",
  "Aloita keskustelu": "Aloita keskustelu",
  "Yksityiset keskustelut": "Yksityiset keskustelut",
  "Ei kanavia": "Ei kanavia",
  "Ryhmäkeskustelut": "Ryhmäkeskustelut",
  "Keskustelut": "Keskustelut",
  "Viesti poistettu": "Viesti poistettu",
  "Poista viesti": "Poista viesti",
  "Olet ilmoittautunut tapahtumaan": "Olet ilmoittautunut tapahtumaan",
  "Peru ilmoittautuminen": "Peru ilmoittautuminen",
  "Et ole ilmoittautunut tapahtumaan": "Et ole ilmoittautunut tapahtumaan",
  "Ilmoittaudu mukaan": "Ilmoittaudu mukaan",
  "Jätä palaute tai kysymys": "Jätä palaute tai kysymys",
  "Kiitos, viesti lähetetty": "Kiitos, viesti lähetetty",
  "Kirjoita palaute tai kysymys": "Kirjoita palaute tai kysymys",
  "Haluan henkilökohtaisen vastauksen": "Haluan henkilökohtaisen vastauksen",
  "Anna sähköposti tai puhelinnumero": "Anna sähköposti tai puhelinnumero",
  "Miten palautteet käsitellään?": "Miten palautteet käsitellään?",
  "Anna sähköpostiosoite tai puhelinnumero": "Anna sähköpostiosoite tai puhelinnumero",
  "Tervetuloa Piiriin": "Tervetuloa Piiriin",
  "Käyttäjätunnus tai puhelinnumero": "Käyttäjätunnus tai puhelinnumero",
  "Jatka": "Jatka",
  "Salasana": "Salasana",
  "Kirjaudu sisään": "Kirjaudu sisään",
  "Pin koodi": "Pin koodi",
  "Pin koodin saapumisessa voi kestää hetken.": "Pin koodin saapumisessa voi kestää hetken.",
  "Kirjautuminen epäonnistui": "Kirjautuminen epäonnistui",
  "Kirjautuminen epäonnistui, tarkista pin koodi": "Kirjautuminen epäonnistui, tarkista pin koodi",
  "Kirjaudutaan ulos...": "Kirjaudutaan ulos...",
  "Uusimmat": "Uusimmat",
  "Meillä töissä": "Meillä töissä",
  "Piiri-artikkelit": "Piiri-artikkelit",
  "Omat tiedot & asetukset": "Omat tiedot ja asetukset",
  "Tietoa Piiri-sovelluksesta": "Tietoa Piiri-sovelluksesta",
  "Mikä on Piiri Kit?": "Mikä on Piiri Kit?",
  "Tietosuojaseloste": "Tietosuojaseloste",
  "Töissä": "Töissä",
  "Poissa töistä": "Poissa töistä"
}